import { Chart } from "react-charts";
import React from "react";
import { ResizableBox as ReactResizableBox } from "react-resizable";

export default function SVMR() {
    const data = React.useMemo(
        () => [
          {
            label: "Recall Training",
            data: [
              { primary: "Action", secondary: 0.6802342342},
              { primary: "Adventure", secondary: 0.760123122},
              { primary: "Arcade", secondary: 0.77420384238},
              { primary: "Board Games", secondary: 0.865023423},
              { primary: "Card", secondary: 0.9202881831},
              { primary: "Casual", secondary: 0.825901012},
              { primary: "Educational", secondary: 0.878929231},
              { primary: "Family", secondary: 0.82503139838},
              { primary: "Fighting", secondary: 0.89208866},
              { primary: "Indie", secondary: 0.970244234},
              { primary: "Multiplayer", secondary: 0.89013224},
              { primary: "Platformer", secondary: 0.840152353},
              { primary: "Puzzle", secondary: 0.8001311},
              { primary: "RPG", secondary: 0.7270032334},
              { primary: "Racing", secondary: 0.84103178},
              { primary: "Shooter", secondary: 0.828923717},
              { primary: "Simulation", secondary: 0.7301367137},
              { primary: "Sports", secondary: 0.8291010210},
              { primary: "Strategy", secondary: 0.68000012312},
            ],
          }, {
            label: "Recall Testing",
            data: [
              { primary: "Action", secondary: 0.688234220},
              { primary: "Adventure", secondary: 0.761001203},
              { primary: "Arcade", secondary: 0.72490202023},
              { primary: "Board Games", secondary: 0.86012312},
              { primary: "Card", secondary: 0.86230230203},
              { primary: "Casual", secondary: 0.81201201},
              { primary: "Educational", secondary: 0.7250012313},
              { primary: "Family", secondary: 0.799983218},
              { primary: "Fighting", secondary: 0.825042322},
              { primary: "Indie", secondary: 0.848042253},
              { primary: "Multiplayer", secondary: 0.87513222},
              { primary: "Platformer", secondary: 0.770124234},
              { primary: "Puzzle", secondary: 0.8000533664},
              { primary: "RPG", secondary: 0.72489969},
              { primary: "Racing", secondary: 0.85092832372},
              { primary: "Shooter", secondary: 0.819271261},
              { primary: "Simulation", secondary: 0.7250001283172},
              { primary: "Sports", secondary: 0.81927137813},
              { primary: "Strategy", secondary: 0.688121212312},
            ],
          }, 
        ],
        []
      );
      const axes = React.useMemo(
        () => [
          { primary: true, type: 'ordinal', position: 'bottom' },
          { type: 'linear', position: 'left' },
        ], []
      );
      return (
          <ReactResizableBox width={500} height={300} style={{textAlign: "center"}}>
              <strong>Recall of SVM</strong>
              <Chart data={data} axes={axes} tooltip/>
          </ReactResizableBox>
      );
};